<template>
  <validation-observer ref="simpleRules">
    <b-form>
      <b-row>
        <b-col md="3">
          <b-form-group>
            <label>NÚMERO PEDIDO</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="NÚMERO PEDIDO"
            >
              <b-form-input
                  v-model="getPedido.nmr_prdido"
                  :state="errors.length > 0 ? false:null"
                  placeholder="NÚMERO PEDIDO"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group>
            <label>DATA EMISSÃO</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="DATA EMISSÃO"
            >
              <b-form-input
                  v-model="dataEmissaoFormatada"
                  :state="errors.length > 0 ? false:null"
                  placeholder="DATA EMISSÃO"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group>
            <label>REPRESENTANTE</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="REPRESENTANTE"
            >
              <b-form-input
                  v-model="getPedido.representante"
                  :state="errors.length > 0 ? false:null"
                  placeholder="REPRESENTANTE"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group>
            <label>DATA PREVISTA FATURAMENTO</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="DATA PREVISTA FATURAMENTO"
            >
              <b-form-input
                  v-model="dataPrevistaFaturamentoFormatada"
                  :state="errors.length > 0 ? false:null"
                  placeholder="DATA PREVISTA FATURAMENTO"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>CLIENTE</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="CLIENTE"
            >
              <b-form-input
                  v-model="getPedido.cliente"
                  :state="errors.length > 0 ? false:null"
                  placeholder="CLIENTE"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>LOCAL ENTREGA</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="LOCAL ENTREGA"
            >
              <b-form-textarea
                  id="textarea-default"
                  v-model="getPedido.local_entrega"
                  :state="errors.length > 0 ? false:null"
                  placeholder="LOCAL ENTREGA"
                  rows="1"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- <b-col md="6">
          <b-form-group>
            <label>ESTABELECIMENTO</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="ESTABELECIMENTO"
            >
              <b-form-input
                  v-model="getPedido.estabelecimento"
                  :state="errors.length > 0 ? false:null"
                  placeholder="ESTABELECIMENTO"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <b-col md="6">
          <b-form-group>
            <label>TIPO</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="TIPO"
            >
              <b-form-input
                  v-model="getPedido.tipo"
                  :state="errors.length > 0 ? false:null"
                  placeholder="TIPO"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>CONDIÇÃO DE PAGAMENTO</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="CONDIÇÃO DE PAGAMENTO"
            >
              <b-form-input
                  v-model="getPedido.condicao_pagamento"
                  :state="errors.length > 0 ? false:null"
                  placeholder="CONDIÇÃO DE PAGAMENTO"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>NÚMERO PEDIDO CLIENTE</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="NÚMERO PEDIDO CLIENTE"
            >
              <b-form-input
                  v-model="getPedido.numero_pedido_cliente"
                  :state="errors.length > 0 ? false:null"
                  placeholder="NÚMERO PEDIDO CLIENTE"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>PEDIDO REPRESENTANTE</label>
            <validation-provider
                #default="{ errors }"
                name="PEDIDO REPRESENTANTE"
                rules="required"
            >
              <b-form-input
                  v-model="getPedido.pedido_representante"
                  :state="errors.length > 0 ? false:null"
                  placeholder="PEDIDO REPRESENTANTE"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>TIPO FRETE</label>
            <validation-provider
                #default="{ errors }"
                name="TIPO FRETE"
                rules="required"
            >
              <b-form-input
                  v-model="getPedido.tipo_frete"
                  :state="errors.length > 0 ? false:null"
                  placeholder="TIPO FRETE"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>TRANSPORTADORA</label>
            <validation-provider
                #default="{ errors }"
                name="TRANSPORTADORA"
                rules="required"
            >
              <b-form-input
                  v-model="getPedido.transportadora"
                  :state="errors.length > 0 ? false:null"
                  placeholder="TRANSPORTADORA"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton,
} from 'bootstrap-vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Pedido',
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
  },

  data() {
    return {
      pedidoNumeroIntegracao: this.$route.params.id,
    };
  },

  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line
          alert('form submitted!')
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      getPedido: 'PTC_PedidosClient/getDetalhesPedidoPedido',
    }),
    dataEmissaoFormatada() {
      console.log('Pedido Computed: ', this.getPedido);
      if (!this.getPedido.dt_emissao) return '';

      try {
        const data = new Date(this.getPedido.dt_emissao);

        if (isNaN(data.getTime())) return this.getPedido.dt_emissao;

        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        // const horas = String(data.getHours()).padStart(2, '0');
        // const minutos = String(data.getMinutes()).padStart(2, '0');
        // const segundos = String(data.getSeconds()).padStart(2, '0');

        // return `${dia}/${mes}/${ano} - ${horas}:${minutos}:${segundos}`;
        return `${dia}/${mes}/${ano}`;
      } catch (e) {
        console.error('Erro ao formatar data:', e);
        return this.getPedido.dt_emissao;
      }
    },
    dataPrevistaFaturamentoFormatada() {
      if (!this.getPedido.dt_prevista_faturamento) return '';

      try {
        const data = new Date(this.getPedido.dt_prevista_faturamento);

        if (isNaN(data.getTime())) return this.getPedido.dt_prevista_faturamento;

        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();

        return `${dia}/${mes}/${ano}`;
      } catch (e) {
        console.error('Erro ao formatar data prevista faturamento:', e);
        return this.getPedido.dt_prevista_faturamento;
      }
    },
  },
};
</script>
<style scoped lang="scss">

</style>
